import { http } from '~/lib/http'
import { CommentManager, CommentPost } from '~/types/comment'
import { Res } from '~/types/common'
import { cookieAuth } from '~/types/auth'

type Comment = {
    content: string
    blogId: string
    parentCommentId?: string
    usernameReceiver?: string
}

const commentApi = {
    getCommentsBlog: async (slug: string, token?: string) => {
        return (
            await http.get<Res<CommentPost[]>>(`/comments/${slug}`, {
                headers: token
                    ? {
                          Cookie: `${cookieAuth}=${token}`
                      }
                    : {}
            })
        ).data
    },
    createComment: async (data: Comment) => {
        return await http.post<Res<null>>('/comments', data)
    },
    deleteComment: async (id: string) => {
        return await http.delete<Res<null>>(`/comments/${id}`)
    },
    getCommentsByBlogId: async (blogId: string, token?: string) => {
        return (
            await http.get<Res<CommentManager>>(`/manager/comments/${blogId}`, {
                headers: token
                    ? {
                          Cookie: `${cookieAuth}=${token}`
                      }
                    : {}
            })
        ).data
    },
    restoreComment: async (id: string) => {
        return await http.patch<Res<null>>(`/manager/comments/restore/${id}`, undefined)
    }
}

export default commentApi
